(() => {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		for (const targetDetail of footerDetails) {
			targetDetail.addEventListener('click', () => {
				for (const detail of footerDetails) {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				}
			});
		}
		
		// when input[name="consent"] is checked, enable the submit button
		const consentInput = document.querySelector('.newsletter input[name="consent"]');
		const submitButton = document.querySelector('.newsletter button[type="submit"]');
		if (consentInput && submitButton) {
			consentInput.addEventListener('change', () => {
				submitButton.disabled = !consentInput.checked;
			});
		}
	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();